<template>
    <header
        role="navigation"
        class="navbar navbar-expand-md fixed-top navbar-light shadow"
    >
        <b-navbar-toggle
            target="nav-collapse"
            class="navbar-toggler border-0 p-0"
        />

        <span class="navbar-brand mr-0 mr-md-3 p-0 d-inline-flex align-items-center">
            <img
                v-if="logoUrl"
                :src="logoUrl"
                alt="RikordaEventi"
                class="mw-100 mh-100"
            />
        </span>

        <span class="navbar-toggler border-0 p-0"></span>

        <b-navbar
            toggleable="md"
            id="navbarSupportedContent"
            class="navbar-collapse p-0"
        >
            <b-collapse
                id="nav-collapse"
                is-nav
                class="navbar-nav pt-3 pt-md-0 align-items-center text-uppercase p-0"
            >
                <b-nav-item
                    class="mr-md-1 mr-lg-3"
                    v-bind="{ active: isDashboard }"
                    :href="resolveUrl({ name: 'backend-dashboard' })"
                >{{ $t("Dashboard") }}
                </b-nav-item>

                <!--b-nav-item-dropdown
                    :text="$t('Studio')"
                    class="mx-md-1 mx-lg-3"
                    :class="{ active: isStudio }"
                >
                    <b-dropdown-item :href="resolveUrl({ name: 'backend-studio-contacts' })">
                        {{ $t("Contatti") }}
                    </b-dropdown-item>
                </b-nav-item-dropdown-->
                <!-- TODO: sistemare quando da mobile si apre un menu dropdown -->

                <b-nav-item
                    class="mx-md-1 mx-lg-3"
                    v-bind="{ active: isEventi }"
                    :href="resolveUrl({ name: 'backend-galleries' })"
                >{{ $t("Eventi") }}
                </b-nav-item>

                <!--b-nav-item-dropdown
                    :text="$t('Foto')"
                    class="mx-md-1 mx-lg-3"
                    :class="{ active: isEventi }"
                >
                    <b-dropdown-item
                        :href="resolveUrl({ name: 'backend-galleries' })"
                    >
                        {{ $t("Galleria") }}
                    </b-dropdown-item>
                </b-nav-item-dropdown-->

                <b-nav-item-dropdown
                    :text="$t('Vendite')"
                    class="mx-md-1 mx-lg-3"
                    :class="{ active: isSales }"
                >
                    <b-dropdown-item :href="resolveUrl({ name: 'backend-sales-orders' })">
                        {{ $t("Ordini") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        :href="resolveUrl({ name: 'backend-sales-pricelists' })"
                        v-if="!isAgent"
                    >
                        {{ $t("Listini") }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        :href="resolveUrl({ name: 'backend-sales-invoices' })"
                        v-if="!isAgent"
                    >
                        {{ $t("Fatture") }}
                    </b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown
                    :text="$t('Rapporti')"
                    class="mx-md-1 mx-lg-3"
                    :class="{ active: isReports }"
                >
                    <b-dropdown-item :href="resolveUrl({ name: 'backend-reports-visitors' })">
                        {{ $t("Visitatori") }}
                    </b-dropdown-item>
                    <b-dropdown-item :href="resolveUrl({ name: 'backend-reports-email' })">
                        {{ $t("Email") }}
                    </b-dropdown-item>
                    <b-dropdown-item :href="resolveUrl({ name: 'backend-reports-favorites' })">
                        {{ $t("Preferiti") }}
                    </b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item
                    class="mx-md-1 mx-lg-3"
                    v-bind="{ active: isEventi }"
                    :href="resolveUrl({ name: 'backend-tutorial' })"
                >{{ $t("Tutorial") }}
                </b-nav-item>

                <span class="nav-item dropdown text-left text-md-center ml-md-1 ml-lg-3">
                    <b-dropdown
                        class="menu-utente d-inline d-md-inline-flex text-uppercase"
                        right
                    >
                        <template slot="button-content">
                            <span class="d-none d-md-inline">
                                <font-awesome-icon :icon="['fas', 'user']" />
                            </span>&nbsp;<span class="d-inline d-md-none nav-item nav-link text-uppercase p-0">Account</span>
                        </template>
                        <b-dropdown-item :href="resolveUrl({ name: 'backend-user-settings' })">
                            {{ $t("I miei dati") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            :href="resolveUrl({ name: 'backend-settings' })"
                            v-if="!isAgent"
                        >
                            {{ $t("Impostazioni") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="goToWatermark"
                            v-if="!isAgent"
                        >
                            {{ $t("Watermark") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            :href="resolveUrl({ name: 'backend-agents' })"
                            v-if="!isAgent"
                        >
                            {{ $t("Gestione collaboratori") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            :href="resolveUrl({ name: 'backend-privacy-conditions' })"
                            v-if="!isAgent"
                        >
                            {{ $t("Privacy e condizioni") }}
                        </b-dropdown-item>
                        <b-dropdown-divider />
                        <b-dropdown-item
                            href="#"
                            @click.prevent="onLogout()"
                        >
                            {{ $t("Logout") }}
                        </b-dropdown-item>
                    </b-dropdown>
                </span>
            </b-collapse>
        </b-navbar>
    </header>
</template>

<script>
export default {
    name: "BackendHeader",

    data() {
        return {};
    },

    methods: {
        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        },

        goToWatermark() {
            this.$api.backendGetDefaultWatermarkId().then((result) => {
                if (result.idWatermark) {
                    this.$router.push({
                        name: "backend-watermark",
                        params: { idWatermark: result.idWatermark }
                    });
                }
            });
        },

        onLogout() {
            this.$store
                .dispatch("EVENT_BACKEND_AUTH_CLEANUP")
                .then((result) => {
                    console.debug("EVENT_BACKEND_AUTH_CLEANUP", result);
                })
                .catch((error) => {
                    console.error("EVENT_BACKEND_AUTH_CLEANUP", error);
                })
                .finally(() => {
                    this.$router.push({ name: "backend" });
                });
        }
    },

    computed: {
        logoUrl() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.logoUrl ? shopData.logoUrl : "";
        },

        isDashboard() {
            return this.$route.name === "backend-dashboard";
        },

        isStudio() {
            switch (this.$route.name) {
                case "backend-contacts":
                case "backend-email":
                    return true;
                default:
                    return false;
            }
        },

        isEventi() {
            return this.$route.name === "backend-galleries";
        },

        isSales() {
            switch (this.$route.name) {
                case "backend-sales-orders":
                case "backend-sales-pricelists":
                    return true;
                default:
                    return false;
            }
        },

        isReports() {
            switch (this.$route.name) {
                case "backend-reports-visitors":
                case "backend-reports-email":
                case "backend-reports-favorites":
                    return true;
                default:
                    return false;
            }
        },

        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        }
    }
};
</script>

<style scoped>
.navbar-collapse {
    padding: 0 16px;
}
</style>
